var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"title-block"},[_c('v-col',{staticClass:"mt-10"},[_c('h3',[_c('CharSplitText',{attrs:{"text":_vm.data.text}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }